import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { ComboBox, DeliveryMethod } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const DeliveryMethodList = ({
  deliveryMethods,
  locations,
  regions,
  changeLocationIdOfDeliveryMethod,
  locationToDelete,
}) => {
  const theme = useTheme()
  const { t } = useTranslation()
  const availableLocations = locations?.filter(location => location.id !== locationToDelete?.id)

  return (
    <Styles.MainContainer>
      {deliveryMethods?.map(deliveryMethod => (
        <Styles.DeliveryMethodContainer key={deliveryMethod.id}>
          <DeliveryMethod
            data={deliveryMethod}
            regions={regions}
            isEditable={false}
            showSwitch={false}
            showDeliveryMethodLabel={false}
            customBackgroundColor={theme.colors.background.secondary}
          />
          <ComboBox
            label={t('Nueva ubicación de destino')}
            backgroundColor={theme.colors.background.primary}
            value={deliveryMethod.new_location_id}
            menuItems={availableLocations?.map(l => ({ label: `${l.internal_id} | ${l.internal_name}`, value: l.id }))}
            handleChange={e => changeLocationIdOfDeliveryMethod(e.target.value, deliveryMethod.id)}
          />
        </Styles.DeliveryMethodContainer>
      ))}
    </Styles.MainContainer>
  )
}

export default DeliveryMethodList
